import React from 'react';
import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton } from '@fluentui/react';

interface ConfirmationDialogProps {
    isVisible: boolean;
    envelopeId: string;
    finalPrice: number;
    onConfirm: () => void;
    onCancel: () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
    isVisible,
    envelopeId,
    finalPrice,
    onConfirm,
    onCancel
}) => {
    return (
        <Dialog
            hidden={!isVisible}
            onDismiss={onCancel}
            dialogContentProps={{
                type: DialogType.normal,
                title: 'Potvrzení kontroly',
                subText: `Opravdu chcete označit jízdu ${envelopeId} s tržbou ${Math.round(finalPrice)} Kč jako zkontrolovanou?`,
            }}
            styles={{
                main: {
                    borderRadius: '12px',
                    padding: '24px',
                }
            }}
        >
            <DialogFooter>
                <PrimaryButton
                    onClick={onConfirm}
                    iconProps={{ iconName: 'CheckMark' }}
                    styles={{ root: { borderRadius: '6px' } }}
                >
                    Potvrdit
                </PrimaryButton>
                <DefaultButton
                    onClick={onCancel}
                    iconProps={{ iconName: 'Cancel' }}
                    styles={{ root: { borderRadius: '6px' } }}
                >
                    Zrušit
                </DefaultButton>
            </DialogFooter>
        </Dialog>
    );
};
